<template>
    <div class="form-event-interest">
        <div v-if="isLoggedIn">
            <div v-if="!event.event_interest_registered">
                <button-primary
                    buttonIcon="chevron-right"
                    buttonText="Register Interest"
                    :buttonClick="putEventInterest"
                    :buttonDisabled="disabled"
                ></button-primary>
            </div>
            <div v-else>
                <alert-info alert="We have registered your interest and will be in touch about the event."></alert-info>
                <button-regular
                    class="mt-4"
                    buttonIcon="close"
                    buttonText="No longer interested"
                    :buttonClick="deleteEventInterest"
                    :buttonDisabled="disabled"
                ></button-regular>
            </div>
        </div>
        <div v-else>
            <button-dialog
                buttonText="Register Interest"
                dialogTitle="Register Interest"
                dialogContent="form-login-signup"
            ></button-dialog>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'FormEventInterest',
    computed: {
        ...mapState(useStoreAuth, {
            isLoggedIn: 'isLoggedIn',
        }),
        ...mapState(useStoreEvent, {
            event: 'event',
            disabled: 'disabled',
        }),
    },
    methods: {
        ...mapActions(useStoreEvent, {
            putEventInterest: 'putEventInterest',
            deleteEventInterest: 'deleteEventInterest',
        }),
    },
};
</script>
